<script>
  /**
   * Adds a text to the middle of the line.
   * @type {string | null}
   */
  export let text = null;
</script>

<hr data-text={text} {...$$restProps} />

<style src="./divider.scss">
</style>
